import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { ServerErrorAction, ActionTypes } from './error.actions';
import { ToastService } from '../../services/toast.service';

@Injectable()
export class ErrorEffects {
    serverError$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType<ServerErrorAction>(ActionTypes.SERVER_ERROR),
                tap((action) => {
                    this._toastService.createAlert({ message: action.payload });
                })
            ),
        { dispatch: false }
    );

    /**
     *
     * @param _actions$
     * @param _toastService
     */
    constructor(
        private _actions$: Actions,
        private _toastService: ToastService
    ) {}
}
